import React from 'react';
import Page from 'src/components/Page';
import { HashLink as Link } from 'react-router-hash-link';
import routes from 'src/routes';
import CodeSamples from 'src/components/CodeSamples';
import { SampleSteps, SampleStepsDoco } from './QuickStartDoco';

const QuickStart = () => {

    const codeSnippetStep = (stepIdx) => {
                
        return (<div>
            <h3>{SampleStepsDoco[stepIdx].step}</h3>
            <p>{SampleStepsDoco[stepIdx].description}</p>
            {SampleStepsDoco[stepIdx].DocoUrl && <p>API Reference <Link to={routes.api.spec + SampleStepsDoco[stepIdx].DocoUrl}>{SampleStepsDoco[stepIdx].DocoComment}</Link></p>}
            <CodeSamples samples={[
                {
                    language: SampleStepsDoco[stepIdx].language,
                    content: SampleStepsDoco[stepIdx].code
                }
            ]} copyButton={SampleStepsDoco[stepIdx]?.copyButton} />
        </div>);

    }

    return (<Page header="QuickStart">
        <p>
            Learn how to quickly set up a simple iframe implementation payment process.  The iframe solution allows your organisation to avoid dealing with sensitive card and payment details.
        </p>
        <p>
            The iframe method is <b>PCI DSS compliant</b> and supports the <b>SAQ-A standard</b> (<a href="https://listings.pcisecuritystandards.org/documents/Understanding_SAQs_PCI_DSS_v3.pdf" target="_blank" rel="noopener noreferrer">Understanding the SAQs for PCI DSS version 3</a>)
        </p>
        <p>
            To connect to the test environment, ensure you set up your API username, merchant number and password.  Refer to  <Link exact to={routes.api.root}>API - Introduction</Link>.
        </p>

        <h2>Sample</h2>

        <p>The sample is developed in .NET.  If you would like to follow along, you can download <a href="https://dotnet.microsoft.com/download/dotnet/6.0" target="_blank" rel="noopener noreferrer">.NET 6.0 or later</a> and use Visual Studio Code (VSCode) or any text editor to modify and run your code.</p>

        { codeSnippetStep(SampleSteps.Setup) }
        { codeSnippetStep(SampleSteps.CreatePublicFolder1) }
        { codeSnippetStep(SampleSteps.PublicHtmlPage1) }
        { codeSnippetStep(SampleSteps.PublicHtmlPage2) }
        { codeSnippetStep(SampleSteps.PublicJavascript) }
        { codeSnippetStep(SampleSteps.PublicCSS) }
        { codeSnippetStep(SampleSteps.CreateModel) }
        { codeSnippetStep(SampleSteps.CreateController) }
        { codeSnippetStep(SampleSteps.AddRESTfulReference) }
        { codeSnippetStep(SampleSteps.UserNamePassword) }
        { codeSnippetStep(SampleSteps.BoilerPlate) }
        { codeSnippetStep(SampleSteps.Build) }
        { codeSnippetStep(SampleSteps.Run) }
        { codeSnippetStep(SampleSteps.Demo) }
        
    </Page>);
}

export default QuickStart;